import React, { useState } from 'react';
import './Internship_Reg.css';
import { UserContext } from '../UserContext';
import { useContext } from 'react';
import GuestNav from '../Navbars/GuestNav';
import Footer from "../Footer";
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Internship_Reg = () => {
  const { isGuest, userInfo } = useContext(UserContext);
  const username = userInfo?.username;
  
  // Form state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    parentName: '',
    gender: '',
    whatsappNumber: '',
    email: '',
    address: '',
    country: null,
    city: '',
    school: '',
    lastDegree: null,
    profilePic: null,
    age: '',
    // New computer science knowledge fields
    wordKnowledge: '',
    excelKnowledge: '',
    pptKnowledge: '',
    graphic: [],
    problemSolving: '',
    techInterest: '',
    projectExperience: '',
    internetSafety: ''
  });

  // Country options
  const countryOptions = countryList().getData();

  // Knowledge level options
  const knowledgeOptions = [
    { value: 'no_knowledge', label: 'No Knowledge' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }
  ];

  // Programming language options
  const GraphicOptions = [
    { value: 'canva', label: 'Canva' },
    { value: 'photoshop', label: 'Photoshop' },
    { value: 'illustrator', label: 'Illustrator' },
    { value: 'coreldraw', label: 'Coreldraw' },
    { value: 'figma', label: 'Figma' }
    
  ];

  // Problem solving options
  const problemSolvingOptions = [
    { value: 'never', label: 'Never tried' },
    { value: 'sometimes', label: 'Beginner' },
    { value: 'enjoy', label: 'Intermediate' },
    { value: 'love', label: 'Expert' }
  ];


  // Project experience options
  const projectOptions = [
    { value: 'none', label: 'None' },
    { value: 'school', label: 'School projects only' },
    { value: 'personal', label: 'Personal projects' },
    { value: 'competitions', label: 'Competition projects' }
  ];

  // Internet safety knowledge
  const safetyOptions = [
    { value: 'basic', label: 'Basic knowledge' },
    { value: 'moderate', label: 'Moderate knowledge' },
    { value: 'advanced', label: 'Advanced knowledge' },
    { value: 'expert', label: 'Expert knowledge' }
  ];

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle file uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  // Handle country select
  const handleCountryChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      country: selectedOption
    }));
  };

  // Handle programming languages select
  const handleLanguagesChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      graphic: selectedOptions
    }));
  };

  // Handle other knowledge selects
  const handleKnowledgeSelect = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption.value
    }));
  };

  // Update the handleSubmit function in your React component
const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Validate age
  const age = parseInt(formData.age);
  if (age < 12 || age > 17) {
    toast.error('Age must be between 12 and 17 years');
    return;
  }

  // Validate WhatsApp number (basic format check)
  const whatsappRegex = /^\+?[\d\s-]{10,}$/;
  if (!whatsappRegex.test(formData.whatsappNumber)) {
    toast.error('Please enter a valid WhatsApp number');
    return;
  }

  // Validate email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.email)) {
    toast.error('Please enter a valid email address');
    return;
  }

  try {
    const formDataToSend = new FormData();
    
    // Append all form fields
    formDataToSend.append('firstName', formData.firstName.trim());
    formDataToSend.append('lastName', formData.lastName.trim());
    formDataToSend.append('parentName', formData.parentName.trim());
    formDataToSend.append('gender', formData.gender);
    formDataToSend.append('whatsappNumber', formData.whatsappNumber.trim());
    formDataToSend.append('email', formData.email.trim());
    formDataToSend.append('address', formData.address.trim());
    formDataToSend.append('country', formData.country ? formData.country.label : '');
    formDataToSend.append('city', formData.city.trim());
    formDataToSend.append('school', formData.school ? formData.school.trim() : '');
    formDataToSend.append('age', formData.age);
    
    // Append computer science knowledge fields
    formDataToSend.append('wordKnowledge', formData.wordKnowledge);
    formDataToSend.append('excelKnowledge', formData.excelKnowledge);
    formDataToSend.append('pptKnowledge', formData.pptKnowledge);
    formDataToSend.append('graphic', JSON.stringify(formData.graphic.map(lang => lang.value)));
    formDataToSend.append('problemSolving', formData.problemSolving);
    formDataToSend.append('projectExperience', formData.projectExperience);
    formDataToSend.append('internetSafety', formData.internetSafety);
    
    // Validate and append files
    if (!formData.lastDegree) {
      toast.error('Please upload your last degree/certificate');
      return;
    }
    if (!formData.profilePic) {
      toast.error('Please upload your profile picture');
      return;
    }

    // Validate file types
    const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const allowedDocTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

    if (!allowedDocTypes.includes(formData.lastDegree.type)) {
      toast.error('Last degree/certificate must be a PDF or image file (JPG, JPEG, PNG)');
      return;
    }

    if (!allowedImageTypes.includes(formData.profilePic.type)) {
      toast.error('Profile picture must be an image file (JPG, JPEG, PNG)');
      return;
    }

    // Validate file sizes (max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (formData.lastDegree.size > maxSize) {
      toast.error('Last degree/certificate file size must be less than 5MB');
      return;
    }
    if (formData.profilePic.size > maxSize) {
      toast.error('Profile picture file size must be less than 5MB');
      return;
    }

    formDataToSend.append('lastDegree', formData.lastDegree);
    formDataToSend.append('profilePic', formData.profilePic);

    const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/internshipregister`, {
      method: 'POST',
      body: formDataToSend
    });

    const data = await response.json();

    if (data.success) {
      toast.success('Registration successful! We will contact you soon.');
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        parentName: '',
        gender: '',
        whatsappNumber: '',
        email: '',
        address: '',
        country: null,
        city: '',
        school: '',
        lastDegree: null,
        profilePic: null,
        age: '',
        wordKnowledge: '',
        excelKnowledge: '',
        pptKnowledge: '',
        graphic: [],
        problemSolving: '',
        techInterest: '',
        projectExperience: '',
        internetSafety: ''
      });
    } else {
      toast.error(data.message || 'Registration failed. Please try again.');
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    toast.error('An error occurred while submitting the form. Please try again.');
  }
};
  return (
    <>
      {!username && isGuest && <GuestNav />}
      <div className="internship-reg-container">
        <div className="registration-header">
          <h1>Join Today </h1>
          <h1> <span>Learn & Intern: Teen Program</span> </h1>
          <p>Fill out the form below to apply for our exciting Internship program for Teens </p>
        </div>

        <div className="registration-form-container">
          <form onSubmit={handleSubmit} className="registration-form">
            <div className="form-section">
              <h2>Personal Information</h2>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name*</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name*</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="parentName">Parent/Guardian Name*</label>
                  <input
                    type="text"
                    id="parentName"
                    name="parentName"
                    value={formData.parentName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="age">Age*</label>
                  <input
                    type="number"
                    id="age"
                    name="age"
                    value={formData.age}
                    onChange={handleChange}
                    min="12"
                    max="17"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="gender">Gender*</label>
                  <select
                    id="gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                    <option value="prefer_not_to_say">Prefer not to say</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="whatsappNumber">WhatsApp Number*</label>
                  <input
                    type="tel"
                    id="whatsappNumber"
                    name="whatsappNumber"
                    value={formData.whatsappNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="address">Address*</label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="country">Country*</label>
                  <Select
                    id="country"
                    name="country"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={countryOptions}
                    value={formData.country}
                    placeholder="Select Country"
                    onChange={handleCountryChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="city">City*</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="school">School Name*</label>
                <input
                  type="text"
                  id="school"
                  name="school"
                  value={formData.school}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group file-upload">
                  <label htmlFor="lastDegree">Upload Copy of Recent School Result*</label>
                  <input
                    type="file"
                    id="lastDegree"
                    name="lastDegree"
                    onChange={handleFileChange}
                    accept=".pdf,.jpg,.jpeg,.png"
                    required
                  />
                  <div className="file-info">
                    {formData.lastDegree ? formData.lastDegree.name : 'No file chosen'}
                  </div>
                </div>
                <div className="form-group file-upload">
                  <label htmlFor="profilePic">Upload Profile Picture*</label>
                  <input
                    type="file"
                    id="profilePic"
                    name="profilePic"
                    onChange={handleFileChange}
                    accept=".jpg,.jpeg,.png"
                    required
                  />
                  <div className="file-info">
                    {formData.profilePic ? formData.profilePic.name : 'No file chosen'}
                  </div>
                </div>
              </div>
            </div>

            <div className="form-section knowledge-assessment">
              <h2>Computer Science Knowledge Assessment</h2>
              <p className="section-description"> Please answer these questions to help us understand your current skills</p>
              
              <div className="assessment-question">
                <label>How would you rate your knowledge of Microsoft Word?</label>
                <div className="radio-options-grid">
                  {knowledgeOptions.map(option => (
                    <label key={option.value} className="radio-option">
                      
                      <input
                        type="radio"
                        name="wordKnowledge"
                        value={option.value}
                        checked={formData.wordKnowledge === option.value}
                        onChange={handleChange}
                        required
                      />
                      
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

              <div className="assessment-question">
                <label>How would you rate your knowledge of Microsoft Excel?</label>
                <div className="radio-options-grid">
                  {knowledgeOptions.map(option => (
                    <label key={option.value} className="radio-option">
                      <input
                        type="radio"
                        name="excelKnowledge"
                        value={option.value}
                        checked={formData.excelKnowledge === option.value}
                        onChange={handleChange}
                        required
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

              <div className="assessment-question">
                <label>How would you rate your knowledge of PowerPoint?</label>
                <div className="radio-options-grid">
                  {knowledgeOptions.map(option => (
                    <label key={option.value} className="radio-option">
                      <input
                        type="radio"
                        name="pptKnowledge"
                        value={option.value}
                        checked={formData.pptKnowledge === option.value}
                        onChange={handleChange}
                        required
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

             

              <div className="assessment-question">
                <label>Which graphic softwares are you familiar with? (Select all that apply)</label>
                <Select
                  isMulti
                  name="graphic"
                  options={GraphicOptions}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  value={formData.graphic}
                  onChange={handleLanguagesChange}
                  required
                />
              </div>

              <div className="assessment-question">
                <label>How would you describe your problem-solving skills?</label>
                <div className="radio-options-grid">
                  {problemSolvingOptions.map(option => (
                    <label key={option.value} className="radio-option">
                      <input
                        type="radio"
                        name="problemSolving"
                        value={option.value}
                        checked={formData.problemSolving === option.value}
                        onChange={handleChange}
                        required
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

              
              <div className="assessment-question">
                <label>Do you have experience working on any tech projects?</label>
                <div className="radio-options-grid">
                  {projectOptions.map(option => (
                    <label key={option.value} className="radio-option">
                      <input
                        type="radio"
                        name="projectExperience"
                        value={option.value}
                        checked={formData.projectExperience === option.value}
                        onChange={handleChange}
                        required
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

              <div className="assessment-question">
                <label>How would you rate your knowledge of internet browsing?</label>
                <div className="radio-options-grid">
                  {safetyOptions.map(option => (
                    <label key={option.value} className="radio-option">
                      <input
                        type="radio"
                        name="internetSafety"
                        value={option.value}
                        checked={formData.internetSafety === option.value}
                        onChange={handleChange}
                        required
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button type="submit" className="submit-button">
                Submit Application
              </button>
              <p className="form-note">
                * Required fields. Your information is secure and will only be used for program registration.
              </p>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Internship_Reg;